// src/components/dashboard/LastPayrollCard.js
// Dashboard card — most recent processed payroll run summary.
// Visibility gated by `payroll:view` via src/config/dashboardCards.js.

import { dashboardService } from "../../services/dashboardService";
import Icon from "../icons/Icon";

export const LastPayrollCard = ({
  isLoading,
  lastPayroll,
  canProcessPayroll,
  navigate,
  company,
}) => (
  <div className="dashboard-card">
    <div className="dashboard-card__header">
      <span className="dashboard-card__title">Last Processed Payroll</span>
    </div>
    {isLoading ? (
      <div className="dashboard-card__loading">Loading...</div>
    ) : lastPayroll ? (
      <>
        <div className="last-payroll__period">
          {dashboardService.formatPeriod(
            lastPayroll.periodStart,
            lastPayroll.periodEnd,
          )}
        </div>
        <div className="last-payroll__stats">
          <div className="last-payroll__stat">
            <span className="last-payroll__stat-label">Employees</span>
            <span className="last-payroll__stat-value">
              {lastPayroll.summary.totalEmployees}
            </span>
          </div>
          <div className="last-payroll__stat">
            <span className="last-payroll__stat-label">Gross Pay</span>
            <span className="last-payroll__stat-value last-payroll__stat-value--gross">
              {dashboardService.formatCurrency(lastPayroll.summary.totalGross)}
            </span>
          </div>
          <div className="last-payroll__stat">
            <span className="last-payroll__stat-label">Gov't Contributions</span>
            <span className="last-payroll__stat-value last-payroll__stat-value--deductions">
              {dashboardService.formatCurrency(
                lastPayroll.summary.totalDeductions,
              )}
            </span>
          </div>
          <div className="last-payroll__stat">
            <span className="last-payroll__stat-label">Loans</span>
            <span className="last-payroll__stat-value last-payroll__stat-value--deductions">
              {/* PRD_LoansManagement C8j — absent on parents written before loans existed */}
              {dashboardService.formatCurrency(
                lastPayroll.summary.totalLoans || 0,
              )}
            </span>
          </div>
          <div className="last-payroll__stat">
            <span className="last-payroll__stat-label">Adjustments</span>
            <span
              className={`last-payroll__stat-value ${
                (lastPayroll.summary.totalAdjustments || 0) >= 0
                  ? "last-payroll__stat-value--adjustments-positive"
                  : "last-payroll__stat-value--adjustments-negative"
              }`}
            >
              {(lastPayroll.summary.totalAdjustments || 0) >= 0 ? "+" : ""}
              {dashboardService.formatCurrency(
                lastPayroll.summary.totalAdjustments || 0,
              )}
            </span>
          </div>
          <div className="last-payroll__stat last-payroll__stat--highlight">
            <span className="last-payroll__stat-label">Net Pay</span>
            <span className="last-payroll__stat-value last-payroll__stat-value--net">
              {dashboardService.formatCurrency(lastPayroll.summary.totalNet)}
            </span>
          </div>
        </div>
      </>
    ) : (
      <div className="empty-state">
        <div className="empty-state__icon"><Icon name="clipboard-list" size={32} /></div>
        <div className="empty-state__title">No payroll processed yet</div>
        <div className="empty-state__text">
          Once you complete your first payroll run, the summary will appear here.
        </div>
        {canProcessPayroll && (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/company/${company.slug}/payroll/process`);
            }}
            className="dashboard-card__link"
          >
            Process your first payroll →
          </a>
        )}
      </div>
    )}
    {lastPayroll && (
      <div className="dashboard-card__footer">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/company/${company.slug}/payroll`);
          }}
          className="dashboard-card__link"
        >
          View payroll details →
        </a>
      </div>
    )}
  </div>
);